module.exports = __webpack_public_path__ + "media/Loops 110 Strings.81d32493.wav";